import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { FailedLoginComponent } from "./features/login/failed-login.component";
import { MaintenancePageComponent } from "./features/maintenance-page/maintenance-page.component";
import { LogoutComponent } from "./features/logout/logout.component";
import { moduleVisibilityGuard } from "./guards/module-visibility.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "home",
    loadComponent: () =>
      import("./features/home/home.component").then((mod) => mod.default),
    canActivate: [MsalGuard],
  },
  {
    path: "administration",
    loadChildren: () =>
      import("./features/administration/administration.component").then(
        (m) => m.admin_routes
      ),
    canActivate: [MsalGuard, moduleVisibilityGuard],
    data: { moduleKey: 'administration' },
  },
  {
    path: "risk-assessments",
    loadChildren: () =>
      import("./features/risk-assessments/risk-assessments.component").then(
        (mod) => mod.risk_assessments_routes
      ),
    canActivate: [MsalGuard, moduleVisibilityGuard],
    data: { moduleKey: 'risk-assessments' },
  },
  {
    path: "audit-planning",
    loadChildren: () =>
      import("./features/planning/audit-planning.component").then(
        (mod) => mod.audit_planning_routes
      ),
    canActivate: [MsalGuard, moduleVisibilityGuard],
    data: { moduleKey: 'audit-planning' },
  },
  {
    path: "scenario",
    loadChildren: () =>
      import("./features/scenario/scenario.component").then(
        (mod) => mod.scenario_routes
      ),
    canActivate: [MsalGuard, moduleVisibilityGuard],
    data: { moduleKey: 'scenario' },
  },
  {
    path: "ics",
    loadChildren: () =>
      import("./features/ics/ics.routes").then(
        (mod) => mod.ICS_ROUTES
      ),
    canActivate: [MsalGuard, moduleVisibilityGuard],
    data: { moduleKey: 'ics-campaign' },
  },
  {
    path: "audit-self-assessment",
    loadChildren: () =>
      import("./features/audit-self-assessment/audit-self-assessment.component").then(
        (m) => m.audit_self_assessment_routes
      ),
    canActivate: [MsalGuard, moduleVisibilityGuard],
    data: { moduleKey: 'audit-self-assessment' },
  },
  {
    path: "planner",
    loadChildren: () =>
      import("./features/planner-tool/planner-tool/planner-tool.component").then(
        (m) => m.plannerToolRoutes
      ),
    canActivate: [MsalGuard, moduleVisibilityGuard],
    data: { moduleKey: 'planner' },
  },
  {
    path: "login-failed",
    component: FailedLoginComponent,
  },
  {
    path: "**",
    component: MaintenancePageComponent,
  },
  {
    path: "logout",
    component: LogoutComponent,
  },
];

